<div class="confirmation-dialog">
  <h2 class="confirmation-dialog__title">{{ data.title }}</h2>
  <div class="confirmation-dialog__message" [innerHTML]="data.message"></div>
  <div class="confirmation-dialog__actions">
    <button mat-stroked-button class="confirmation-dialog__cancel-btn" (click)="onCancel()">
      {{ data.cancelButtonText || ('translations.global.button.cancel' | transloco) }}
    </button>
    <button mat-flat-button color="primary" class="confirmation-dialog__confirm-btn" (click)="onConfirm()">
      {{ data.confirmButtonText || ('translations.global.button.confirm' | transloco) }}
    </button>
  </div>
</div>
